module.exports = __webpack_public_path__ + "08ff9f1e193f6fb7d806107f8738a0f4.pdf";